import noop from 'lodash/noop'
import { createContext } from 'react'
export default createContext({
  formData: {},
  setFormData: noop
})
